import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

// const SERVER_IP = process.env.REACT_APP_IP;
const API_URL = `/api`;

function App() {
  const [message, setMessage] = useState('');
  const [metadata, setMetadata] = useState([]);
  const [imageB64, setImageB64] = useState('');
  const [imageB64String, setimageB64String] = useState('');
  const [searchMode, setSearchMode] = useState("similar");
  const [resultLimit, setResultLimit] = useState(9);
  const [exploreModeOn, setExploreModeOn] = useState(false);

  // called when file is changed by user (in html below)
  // starts file submission process
  const handleFileChange = (e) => {
    if(e.target.files.length >= 1) {
      var imageFile = e.target.files[0];
      handleFileSubmission(imageFile);
    }
  };


  async function performSearch(imageB64, searchMode, resultLimit) {
    setMessage("Searching...");
    try {
      const formData = new FormData();
      formData.append('imageB64', imageB64);
      formData.append('searchMode', searchMode);
      formData.append('resultLimit', resultLimit);
  
      const response = await axios.post(`${API_URL}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  
      handleSearchResponse(response);
    } catch (error) {
      setMessage('Failed to upload image');
      console.error("Error uploading image:", error);
    }
  }

  // called when user presses Upload (in html below)
  // sends request to server/app.js/upload
  // calls handleSearchResponse if the request if successful
  const handleSubmit = async (e) => {
    e.preventDefault();
    performSearch(imageB64, searchMode, resultLimit);
  };

  // called after the search response is attained
  // saves metadata
  function handleSearchResponse(response) {
    // search unsuccessful:
    if(response.data.success === "False") {
      let displayMessage = "Error: "+response.data.message
      setMessage(displayMessage);
      console.log(displayMessage);
      return;
    }
    // otherwise, search successful
    setMetadata(response.data.metadata);
    console.log(`metadata set successfully\nquantity: ${response.data.metadata.length}`);
    setMessage(response.data.message);
  }



  // called to handle the file submission
  // reads the imageFile as base64 string
  // calls handleFileString after the imageFile is read
  function handleFileSubmission(imageFile) {
    setMessage("Setting file...");
    var reader = new FileReader();
    reader.onloadend = function() {
      handleFileString(reader.result);
      setMessage("Press Upload to Search");
    }
    reader.readAsDataURL(imageFile);
  }

  // called after the rawFileString is attained
  // generates and saves imageB64 and imageB64Full
  function handleFileString(rawFileString) {
    setimageB64String(rawFileString);
    var base64result = rawFileString.split(',')[1];
    setImageB64(base64result);
  }

  // used to turn on explore mode (make results searchable)
  async function handleExploreClick(item) {
    try {
      // fetch the image from its link
      const response = await fetch(item.large_link);
      const blob = await response.blob();
  
      // convert the Blob to a base64-encoded string
      const rawFileString = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
      });
  
      // rawFileString is like "data:image/jpeg;base64,ABC..."
      setimageB64String(rawFileString);            // For displaying in <img src=... />
      const base64result = rawFileString.split(',')[1];
      setImageB64(base64result);  
  
      // optionally, a new search could immedialy get called with this new image:
      // performSearch(base64result, searchMode, resultLimit);
  
      setMessage("Image loaded! Press 'Upload' to Search again.");
    } catch (error) {
      console.error("Error loading image for explore click:", error);
      setMessage("Error loading image from result link.");
    }
  }

  return (
    <div id="app-container">
      {/* Top Bar */}
      <div id="top-bar">SCA Image Search</div>
  
      {/* Main Content */}
      <div id="main-content">
        {/* Upload/Search Area */}
        <div id="upload-section">
          <div className="uploaded-image-container">
            {imageB64String ? (
              <img
                src={imageB64String}
                alt="Uploaded"
                className="uploaded-image"
              />
            ) : (
              <div className="placeholder">Image Uploaded appears here</div>
            )}
          </div>
          <form onSubmit={handleSubmit} className="upload-form">
            <input type="file" onChange={handleFileChange} />
            <button type="submit">{exploreModeOn ? "Update Search" : "Search"}</button>
          </form>
          <div className="search-mode-toggle">
            <label className={`mode-option ${searchMode === "similar" ? "selected" : ""}`}>
              <input
                type="radio"
                value="similar"
                checked={searchMode === "similar"}
                onChange={(e) => setSearchMode(e.target.value)}
              />
              Similar
            </label>
            <label className={`mode-option ${searchMode === "non-similar" ? "selected" : ""}`}>
              <input
                type="radio"
                value="non-similar"
                checked={searchMode === "non-similar"}
                onChange={(e) => setSearchMode(e.target.value)}
              />
              Non-Similar
            </label>
          </div>
          <div className="toggle-wrapper">
            <span className="toggle-text" title="Enable Explore Mode to load clicked images back into the search">Explore Mode  </span>
            <div
              className="toggle-switch"
              title="Enable Explore Mode to load clicked images back into the search"
            >
              <input
                type="checkbox"
                id="exploreToggle"
                checked={exploreModeOn}
                onChange={() => {
                  setExploreModeOn(!exploreModeOn)
                  exploreModeOn ? setMessage("You've exited explore mode. You can now click on results to get more info about them.") :
                  setMessage("You've entered explore mode. You can now click on results to choose them as your next query.")
                }}
              />
              <label htmlFor="exploreToggle" className="toggle-switch-label" />
            </div>
          </div>
        
          <div className="result-limit-slider">
            <label htmlFor="limitSlider">Number of Results: {resultLimit} </label>
            <input
              id="limitSlider"
              type="range"
              min="3"
              max="15"
              step="3"
              value={resultLimit}
              onChange={(e) => setResultLimit(parseInt(e.target.value))}
            />
          </div>
          {message && <p>{message}</p>}
          {metadata.length > 0 && (
            <p className="instructions">Click on results to learn more!</p>
          )}
        </div>
  
        {/* Results Grid */}
        <div id="search-results-section">
          {metadata.map((item, index) => {
            return (
              <div key={index} className="search-result-item">
                {exploreModeOn ? (
                  /* explore Mode ON */
                  <img
                    src={item.large_link}
                    alt={`Result ${index + 1}`}
                    className="result-image"
                    onClick={() => handleExploreClick(item)}
                    onError={(e) => {
                      if (e.target.src !== item.fallback_link) {
                        e.target.src = item.fallback_link;
                      } else if (e.target.src !== item.thumbnail_link) {
                        e.target.src = item.thumbnail_link;
                      } else {
                        e.target.alt = 'Image failed to load';
                      }
                    }}
                  />
                ) : (
                  /* explore Mode OFF (normal behavior) */
                  <a href={item.web_link} target="_blank" rel="noopener noreferrer">
                    <img
                      src={item.large_link}
                      alt={`Result ${index + 1}`}
                      className="result-image"
                      onError={(e) => {
                        if (e.target.src !== item.fallback_link) {
                          e.target.src = item.fallback_link;
                        } else if (e.target.src !== item.thumbnail_link) {
                          e.target.src = item.thumbnail_link;
                        } else {
                          e.target.alt = 'Image failed to load';
                        }
                      }}
                    />
                  </a>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
}

export default App;
